import React,{memo} from 'react';

const Content = memo((props:any) => {
    return (
        <div className="content-body" id="content-body" style={{backgroundColor: '#ffffff'}}>
            {props.children}
        </div>
    )
})

export default Content;